import React from "react";
import BackButton from "./BackButton";
import BackToHomeButton from "../Buttons/BackToHomeButton";
import AdminLoginButton from "../Buttons/AdminLoginButton";
import LogoutButton from "../Buttons/LogoutButton";

const Header = ({
  heading,
  showBackButton = false,
  showAdminLoginButton = false,
  showAdminLogoutButton = false,
  backToHomePageButton = false,
}) => {

  return (
    <div className="relative flex items-center justify-center px-4 py-4 border-b shadow-sm bg-white max-w-3xl mx-auto">
      {/* Back Button */}
      {showBackButton && <BackButton />}

      {/* Back To Home Button */}
      {backToHomePageButton && <BackToHomeButton />}

      {/* Heading (Centered) */}
      <div className="w-full flex-column">
        <h1 className="text-2xl font-bold text-[#df670e] flex-1 text-center">
          {heading}
        </h1>
        <div className="text-[#df670e] text-xl flex-1 text-center">
          One Nation, One Election
        </div>
      </div>

      {/* Admin Login Button */}
      {showAdminLoginButton && <AdminLoginButton />}

      {/* Admin LogOut Button */}
      {showAdminLogoutButton && <LogoutButton />}
    </div>
  );
};

export default Header;
